import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function MemberClasses() {
  const [classes, setClasses] = useState([]);
  const [msg, setMsg] = useState({});

  useEffect(() => { axios.get('/member/classes').then(r => setClasses(r.data)); }, []);

  const book = async id => {
    try { await axios.post(`/member/classes/${id}/book`); setMsg(p => ({...p, [id]: { ok:true, text:'Booked! ✓' }})); }
    catch (err) { setMsg(p => ({...p, [id]: { ok:false, text: err.response?.data?.message || 'Error' }})); }
  };

  const days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">Group classes</h1><p className="page-sub">Book your spot in a class</p></div></div>

      {days.map(day => {
        const dc = classes.filter(c => c.schedule_day === day);
        if (!dc.length) return null;
        return (
          <div key={day} style={{ marginBottom:18 }}>
            <div style={{ fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'.07em', color:'var(--text-muted)', marginBottom:8 }}>{day.charAt(0).toUpperCase()+day.slice(1)}</div>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {dc.map(c => (
                <div key={c.id} className="card" style={{ padding:0 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:16, padding:'14px 18px' }}>
                    <div style={{ width:52, textAlign:'center', flexShrink:0 }}>
                      <div style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:700, color:'var(--accent)' }}>{c.schedule_time?.slice(0,5)}</div>
                      <div style={{ fontSize:10, color:'var(--text-muted)' }}>{c.duration_mins} min</div>
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:600 }}>{c.name}</div>
                      <div style={{ fontSize:12, color:'var(--text-muted)' }}>
                        {c.trainer_name && `with ${c.trainer_name} · `}{c.room && `${c.room} · `}{c.bookings_count}/{c.capacity} booked
                      </div>
                    </div>
                    <div>
                      {msg[c.id] ? (
                        <span style={{ fontSize:13, fontWeight:600, color: msg[c.id].ok ? 'var(--success)' : 'var(--danger)' }}>{msg[c.id].text}</span>
                      ) : (
                        <button className="btn-primary" style={{ fontSize:12, padding:'7px 14px' }} disabled={c.bookings_count >= c.capacity} onClick={() => book(c.id)}>
                          {c.bookings_count >= c.capacity ? 'Full' : 'Book spot'}
                        </button>
                      )}
                    </div>
                  </div>
                  {c.description && <div style={{ padding:'0 18px 12px', fontSize:12, color:'var(--text-secondary)' }}>{c.description}</div>}
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {classes.length === 0 && <div className="card"><div className="empty-state" style={{ padding:40 }}><div className="icon">🗓️</div><p>No classes scheduled yet.</p></div></div>}
    </div>
  );
}
